import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import useButtonStyles from "../../styles/useButtonStyles";
import theme from "../../theme";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useDispatch } from "react-redux";
import {
  shopUserActions,
} from "../../redux/slices/shopUserSlice";
import formatDate from "../../util/dateFormat";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { AddShopUser } from "./AddShopUser";
import UpdateShopUser from "./UpdateShopUser";
import { UpdateShopUserDetails } from "./UpdateShopUserDetails";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { getEncodedLastkey, getEncodedValue } from "../forms/utility";
import {
  SearchToolTip,
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
const listOfStatus = [filterConstants.Active, filterConstants.Inactive];
interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}

export function ShopUsers() {
  const buttonStyles = useButtonStyles();

  const columns: TableColumn[] = [
    { key: "name", header: "Name" },
    { key: "email", header: "Email" },
    { key: "mobileNumber", header: "Mobile Number" },
    { key: "merchant", header: "Merchant" },
    { key: "companyName", header: "Company Name" },
    { key: "role", header: "Role" },
    { key: "status", header: "Status" },
  ];
 
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [lastKey, setLastKey] = useState(null);
  const [addShopUser, setAddShopUser] = useState(false);
  const [updateShopUser, setUpdateShopUser] = useState(false);
  const [updateShopUserDetails, setUpdateShopUserDetails] = useState(false);
  const [shopUser, setShopUser] = useState<any>({});
  const [apiCall, setIsApiCall] = useState(true);
  const [filterActive, setFilterActive] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const { getUserPermission: getShopUserPermissions } = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.shop_user
  );
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const { shopuserId } = params;
  const shopUserList = useAppSelector(
    (state: any) => state.persistReducers.shopUserSlice?.shopUserList
  );
  const searchInputRef = useRef<HTMLInputElement>();
  useEffect(() => {
    if (shopuserId) {
      const singleShopper = shopUserList.filter(
        (shopper: any) => shopper?.id === shopuserId
      );
      const shop = singleShopper[0];
      setShopUser(shop);
      setUpdateShopUser(true);
    }
  }, [shopuserId]);

  const fetchShopUserList = async (url: string, canMergeData?: boolean) => {
    setLoading(true);
    let currentURl = url;
    try {
      // getTotalCounts(currentURl, "data.result.data");
      if (lastKey) {
        currentURl += currentURl.includes("?") ? "&" : "?";
        currentURl += getEncodedLastkey(lastKey);
      }
      currentURl += `&module=merchant&feature=shop_user`;
      const response = await axios.get(currentURl);
      const apiKey = response.data.result.lastKey
        ? response.data.result.lastKey
        : null;
      setLastKey(apiKey);
      const apiData = response.data.result.data;
      const shopUserlistData = apiData.map((item: any) => {
        return {
          email: item.email ? item.email : "-",
          name: item.firstName ? `${item.firstName} ${item.lastName}` : "-",
          status: item.status ? item.status : "-",
          role: item.user_role ? item.user_role : "-",
          department: item.department ? item.department : "-",
          merchant: item.merchant ? item.merchant : "-",
          companyName: item.companyName ? item.companyName : "-",
          mobileNumber: item.mobile && item.mobile !== "0" ? item.mobile : "-",
          lastLogin: item.lastLogin ? formatDate(item.lastLogin) : "-",
          lastName: item.lastName ? item.lastName : "-",
          firstName: item.firstName ? item.firstName : "-",
          designation: item.designation ? item.designation : "-",
          id: item?.id ? item?.id : "-",
          navigateTo: item?.id ? `/admin/SU/${item.id}` : "-",
        };
      });
      shopUserlistData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();
          return dateB - dateA;
        }
      );
      const dataToSet = canMergeData
        ? [...data, ...shopUserlistData]
        : shopUserlistData;
      setData(dataToSet);
      dispatch(
        shopUserActions.updateShopUserList({
          shopUserList: dataToSet,
        })
      );
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setIsApiCall(false);
    }
  };
  useEffect(() => {
    apiCall && bindSearchAndFilter();
  }, [apiCall]);

  const handleUpdate = () => {
    setUpdateShopUser(false);
    setUpdateShopUserDetails(true);
  };
  const NavigateToAdmin = () => {
    setUpdateShopUser(false);
    setUpdateShopUserDetails(false);
    navigate("/admin");
  };
  const [roles, setRoles] = useState<string[]>([]);
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL +
            APIConstants.role +
            "?type=Merchant&module=admin&feature=shop_user"
        );
        const data = response.data.data;

        const roleListData = data.map((item: any) => {
          return {
            name: item.name ? item.name : "-",
            description: item.description ? item.description : "-",
          };
        });

        const roles = data.map((item: any) => {
          return item.name;
        });
        setRoles(roles);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRoleList();
  }, []);

  const [openFilter, setOpenFilter] = useState(false);

  const [filterState, setFilterState] = useState({
    userRole: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      userRole: "",
      status: "",
    });
    setFilterStates([]);
    onResetData();
    setIsApiCall(true);
    setFilterActive(false);
  };
  const handleClose = () => {
    setOpenFilter(false);
  };
  const [filterStates, setFilterStates] = useState<any>([]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const HandleRoleChange = (event: SelectChangeEvent) => {
    getAllFields(
      "user_role",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      userRole: event.target.value,
    }));
  };
  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };
  const applyShopUserFilter = () => {
    onResetData();
    setIsApiCall(true);
    setOpenFilter(false);
    const anyFilterActive = Object.values(filterState).some(
      (value) => value !== ""
    );
    if (anyFilterActive) {
      setFilterActive(true);
    }
  };
  // search

  const handleSearch = () => {
    onResetData();
    setIsApiCall(true);
  };

  const onResetData = () => {
    setData([]);
    setLastKey(null);
  };

  const bindSearchAndFilter = (canMergeData?: boolean) => {
    const hashValue = {
      field: "userType",
      value: "merchant",
    };
    const searchValue = searchInputRef.current
      ? searchInputRef.current.value
      : "";
    const searchParam =
      searchValue.trim() !== "" ? [getEncodedValue(searchValue)] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    const newURL = `${
      process.env.REACT_APP_API_URL + APIConstants.admin
    }?${url}`;
    if (!data.length) getTotalRecordsCount(APIModuleConstants.adminUser, url);
    fetchShopUserList(newURL, canMergeData);
  };
  return (
    <Grid container width={"100%"}>
      <Grid
        item
        display={"flex"}
        justifyContent={"space-between"}
        p={4}
        sx={{ background: theme.color?.background }}
        width={"100%"}
      >
        {getShopUserPermissions("create") && (
          <Button
            sx={{ ...buttonStyles.containedSecondary }}
            variant="contained"
            onClick={() => setAddShopUser(true)}
          >
            Add Shop Users
          </Button>
        )}

        <Drawer
          anchor={"right"}
          open={addShopUser}
          onClose={() => {
            setAddShopUser(false);
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <AddShopUser
              closeShopUser={setAddShopUser}
              fetchShopUserList={() => {
                onResetData();
                setIsApiCall(true);
              }}
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={updateShopUser}
          onClose={() => {
            NavigateToAdmin();
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <UpdateShopUser
              closeDrawer={setUpdateShopUser}
              openUpdate={handleUpdate}
              shopUser={shopUser}
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={updateShopUserDetails}
          onClose={() => {
            NavigateToAdmin();
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"40vw"} height={"100%"}>
            <UpdateShopUserDetails
              shopUser={shopUser}
              closeUpdateShopUserDetails={setUpdateShopUserDetails}
              fetchShopUserList={() => {
                onResetData();
                setIsApiCall(true);
              }}
            />
          </Grid>
        </Drawer>
        {getShopUserPermissions("read") && (
          <Grid display={"flex"} gap={3}>
            <SearchInput
              HelpTip={SearchToolTip.ShopUsers}
              onCallBack={handleSearch}
              ref={searchInputRef}
            />
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{
                color: theme.color?.newFilterGrey,
                textTransform: "capitalize",
              }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          </Grid>
        )}

        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              {/* <IconButton onClick={() => setOpenFilter(false)}> */}
              <IconButton
                onClick={() => {
                  setOpenFilter(false);
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Role
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.userRole}
                        onChange={HandleRoleChange}
                      >
                        {roles.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Status
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.status}
                        onChange={HandleStatusChange}
                      >
                        {listOfStatus.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={resetFilterState}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={applyShopUserFilter}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
      {getShopUserPermissions("read") && (
        <Grid mt={2} padding={2} justifySelf={"center"} width={"100%"}>
          <InfiniteTable
            header={columns}
            contentItems={data}
            hasMoreRecords={lastKey != null}
            fetchMoreData={() => bindSearchAndFilter(true)}
            isInitialLoading={loading && data.length === 0}
            totalRecords={totalCount}
          />
        </Grid>
      )}
    </Grid>
  );
}
